import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=fd9c36e2&scoped=true&"
import script from "./TestView.vue?vue&type=script&lang=js&"
export * from "./TestView.vue?vue&type=script&lang=js&"
import style0 from "./TestView.vue?vue&type=style&index=0&id=fd9c36e2&prod&lang=scss&"
import style1 from "./TestView.vue?vue&type=style&index=1&id=fd9c36e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9c36e2",
  null
  
)

export default component.exports